<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toast } from '@/ui-plus/sonner'
import { useFormPlus } from "@/ui-plus/form/useFormPlus";
import { toTypedSchema } from "@vee-validate/zod";
import { authGlobalApiClient } from '@api-client/auth_global';
import { useForm } from "vee-validate";
import { z } from "zod";
import { Loader2 } from 'lucide-vue-next';
import { showTurnstile } from '@/ui-plus/dialog/showTurnstile';
import { ref } from 'vue';
import { useI18n } from "vue-i18n";
import AutoFormFieldPhone from "@/ui-plus/PhoneNumber/AutoFormFieldPhone.vue";
import { phoneNumberSchema } from "@lib/zod/PhoneNumberArray";
import ChangePhoneCodeForm from '@auth-frontend-vue/components/forms/ChangePhoneCodeForm.vue';


const { t } = useI18n();

withDefaults(defineProps<{
    showCancel?: boolean;
}>(), {
    showCancel: true,
});



const emit = defineEmits<{
    onSuccess: [],
    onCancel: [],
    onError: [error: unknown],
}>();

const schema = z.object({
    phoneNumber: phoneNumberSchema,
})

const form = useForm({
    validationSchema: toTypedSchema(schema)
});
const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);

const otpToken = ref<string | undefined>();
const sentTo = ref('');

async function onSendOtpSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        const { data, error } = await (await authGlobalApiClient.phone.send_otp.$post({
            form: {
                phoneNumber: values.phoneNumber,
                turnstile: await showTurnstile(import.meta.env.PUBLIC_TURNSTILE_SITE_KEY),
            },
        })).json()
        if (error) {
            handleError(error, form);
        } else {
            otpToken.value = data;
            sentTo.value = values.phoneNumber;
            toast.success(t('codeSentToPhone'));
        }
    })
}
</script>

<template>
    <div v-if="!otpToken">
        <p class="text-sm text-muted-foreground mb-4">
            {{ t('changePhoneWarning') }}
        </p>
        <AutoForm class="space-y-6"
                  :schema="schema"
                  :form="form"
                  @submit="onSendOtpSubmit"
                  :field-config="{
                    phoneNumber: {
                        label: t('newPhoneNumber'),
                        component: AutoFormFieldPhone,
                        inputProps: {
                            autofocus: true,
                        },
                    },
                }">
            <div class="text-sm font-medium text-destructive"
                 v-if="globalError">
                {{ globalError }}
            </div>
            <div>
                <Button type="submit"
                        :disabled="isLoading"
                        class="w-full my-6">
                    <Loader2 v-if="isLoading"
                             class="animate-spin" />
                    {{ t('sendClaimEmailCode') }}
                </Button>
            </div>
        </AutoForm>
        <Button v-if="showCancel"
                variant="secondary"
                @click="emit('onCancel')"> {{ t('cancel') }}
        </Button>
    </div>
    <div v-else
         class="space-y-4 py-2">
        <p class="text-sm text-muted-foreground text-center">
            {{ t('claimEmailEnterCode') }}
            <br />
            <span class="font-medium text-foreground">{{ sentTo }}</span>
        </p>
        <ChangePhoneCodeForm :otp-token="otpToken"
                             @on-success="emit('onSuccess')" />
        <Button variant="secondary"
                class="w-full"
                @click="otpToken = undefined">
            {{ t('useDifferentPhone') }}
        </Button>
    </div>
</template>